/* Matching leash add-on (2026-10-29). Tick the box and one reflective leash that matches the item's
   colour joins the same cart add. The leash colour is never picked separately: each item colour maps
   to one leash colour (data.match), and an item colour without a match hides the box.
   Exposes window.MitsiLeash.item() for the product scripts and fires 'mitsi:leash-change'. */
(function () {
  'use strict';
  var root = document.getElementById('leash-addon');
  var node = document.getElementById('leash-data');
  if (!root || !node) return;
  var data = JSON.parse(node.textContent);
  var box = document.getElementById('leash-add');
  var follow = document.getElementById(root.dataset.follow);
  var shownFor = null;

  function itemColor() { return (follow && follow.value) || ''; }
  function variant() {
    var c = data.match[itemColor()];
    return c ? data.variants.find(function (v) { return v.color === c && v.available; }) || null : null;
  }
  function sync() {
    var item = itemColor();
    var v = variant();
    shownFor = item;
    root.hidden = !v;
    if (!v) box.checked = false;
    var c = v ? v.color : '';
    document.getElementById('leash-color-name').textContent = c;
    var pic = document.getElementById('leash-pic');
    if (pic && data.img[c]) { pic.src = data.img[c] + (data.img[c].indexOf('?') === -1 ? '?' : '&') + 'width=240'; pic.alt = c + ' reflective leash'; }
    var photo = document.getElementById('leash-photo');
    if (photo) {
      var src = data.photo && data.photo[item];
      document.getElementById('leash-photo-wrap').hidden = !(box.checked && src);
      if (box.checked && src && photo.dataset.color !== item) {
        photo.dataset.color = item;
        photo.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=720';
        photo.alt = 'A small dog in a ' + item.toLowerCase() + ' quilted vest on the matching reflective leash';
      }
    }
    root.classList.toggle('on', box.checked);
  }
  function changed() {
    sync();
    window.dispatchEvent(new CustomEvent('mitsi:leash-change'));
  }
  // Product scripts may set the colour without a change event, so re-sync whenever they ask.
  function fresh() { if (shownFor !== itemColor()) sync(); }

  window.MitsiLeash = {
    on: function () { fresh(); return box.checked && !!variant(); },
    cents: function () { fresh(); var v = variant(); return box.checked && v ? v.cents : 0; },
    item: function () {
      fresh();
      var v = variant();
      if (!box.checked || !v) return null;
      return { id: v.id, meta: { title: data.title, meta: v.color + ' / 6 ft', cents: v.cents, handle: data.handle, img: data.img[v.color] || '' } };
    }
  };
  box.addEventListener('change', changed);
  if (follow) follow.addEventListener('change', changed);
  sync();
})();
